import React from 'react';
import API_BASE_URL from "../../apis/api";
import { useNavigate } from "react-router-dom";


const resetDatabase = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/reset-db`, {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error("Failed to reset the database");
      }
      const data = await response.json();
      alert("Database reset successfully!");
      console.log("Database reset response:", data);
    } catch (error) {
      console.error("Error resetting database:", error);
      alert("Error resetting database. Please check the console for details.");
    }
  };
const TopBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between pr-14 w-full h-full">
      {/* Company Logo */}
      <button
          onClick={resetDatabase}
        >
          <img
            src="/logosmall.jpg"
            alt="Linearworks Logo"
            className="w-[10%] h-auto"
          />
        </button>
      {/* Logout Button */}
      <button
      className="flex items-center space-x-1 text-font font-bold text-sm hover:text-logo"
      onClick={() => navigate("/")} // Navigate to "/" on click
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        width="30"
        height="30"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
        />
      </svg>
      <span className="text-base">Logout</span>
    </button>
    </div>
  );
};

export default TopBanner;